import React, {useEffect, useState} from 'react';

import Box from "@mui/material/Box";
import Moment from "react-moment";
import {IEvent} from "./Buxliest";
import IconButton from "@mui/material/IconButton";
import DeleteIcon from '@mui/icons-material/Delete';
import axios, {AxiosPromise} from "axios";
import Config from "../../utils/Config";
import RegisterButton from "./RegisterButton";
import Snackbar from "@mui/material/Snackbar";
import {Alert} from "@mui/material";

export interface IEventProps {
  event: IEvent;
  registerSuccessCallback: () => void,
}

const Event = (props: IEventProps) => {
  const [snackbarOpen, setSnackbarOpen] = React.useState(false);
  const handleSnackbarClose = (event: any) => {
    setSnackbarOpen(false);
  };
  const addAttendeeSuccess = () => {
    setSnackbarOpen(true);
    props.registerSuccessCallback();
  };

  const closed = false;
  const seatsAvailable = props.event?.seats - props.event?.attendees?.length;

  return (
    <>
      <Box className="text-2xl font-bold mb-4">{props.event?.title}</Box>
            <Box className="prose max-w-[800px]"
           dangerouslySetInnerHTML={{
             __html: props.event?.field_description.processed.toString().replaceAll("<p>&nbsp;</p>", "") ?? ""
           }}
      ></Box>
      <Box className="italic clear-both mt-6  mb-4">Ort: {props.event?.schedule.place?.title}, {props.event?.schedule.place?.field_place.address_line1}, {props.event?.schedule.place?.field_place.postal_code} {props.event?.schedule.place?.field_place.locality} </Box>

      {!closed && seatsAvailable > 0 && (
        <Box className="text-secondary-500 clear-both mt-6 mb-4"><p>Noch {seatsAvailable} freie Plätze</p></Box>
      )}
      {!closed && seatsAvailable <= 0 && (
        <Box className="text-secondary-500 clear-both mt-6 mb-4"><p>Momentan sind keine Plätze frei. Sie können sich aber auf die Warteliste setzen.</p></Box>
      )}
      {!closed && (
        <RegisterButton event={props.event}
                        successCallback={addAttendeeSuccess}></RegisterButton>
      )}
      {closed && (
        <Box className="text-secondary-500 clear-both mt-6"><p>Der Anmeldeschluss ist erreicht. Es besteht die
          Möglichkeit, sich spontan vor Ort anzumelden - sofern für die Lesung noch Plätze frei sind.</p></Box>
      )}
      <Snackbar open={snackbarOpen} autoHideDuration={8000} onClose={handleSnackbarClose}>
        <Alert onClose={handleSnackbarClose} severity="success">
          Das hat funktioniert. Sie bekommen eine Bestätigung per E-Mail.
        </Alert>
      </Snackbar>
    </>
  );
};
export default Event;
